module.exports = __webpack_public_path__ + "img/icon_home_swipeItem_channelExclusive.a2a4c958.png";